module.exports = __webpack_public_path__ + "img/dark-mud-decal-01.af506cb3.png";